import { QueryListParams } from '../types';

export const videoAttributesKeys = {
  attributes: () => ['VIDEO_ATTRIBUTES'],
  all: (params: QueryListParams) => ['VIDEO_ATTRIBUTES', params],
  detail: (videoId: number) => ['VIDEO_ATTRIBUTES', videoId],
};
